module.exports = __webpack_public_path__ + "media/images/sleepy-time-4cec1c587391fa9d7c1068033bfdffa1.svg";